import { Routes } from '@angular/router';
import { environment } from '../environments/environment';

const routes: Routes = [
  {
    path: 'recordings',
    loadComponent: () =>
      import('./admin-recordings/admin-recordings.component').then(
        (m) => m.AdminRecordingsComponent
      ),
  },
  {
    path: 'call/:namewebsite',
    loadComponent: () =>
      import(
        './webrtc-call/components/website-call/website-call.component'
      ).then((m) => m.WebsiteCallComponent),
  },
  {
    path: 'appel',
    loadComponent: () =>
      import('./wwebappel/wwebappel.component').then(
        (m) => m.WwebappelComponent
      ),
  },
  {
    path: 'webcall',
    loadComponent: () =>
      import('./webappel-en/webappel-en.component').then(
        (m) => m.WebappelEnComponent
      ),
  },
  {
    path: 'agent',
    loadComponent: () =>
      import('./agent-iframe/agent-iframe.component').then(
        (m) => m.AgentIframeComponent
      ),
    children: [
      {
        path: ':id',
        loadComponent: () =>
          import(
            './webrtc-call/components/agent-call/agent-call.component'
          ).then((m) => m.AgentCallComponent),
      },
    ],
  },
  {
    path: 'whatsapp/:roomId',
    loadComponent: () =>
      import('./whatsapp-calls/whatsapp-calls.component').then(
        (m) => m.WhatsappCallsComponent
      ),
  },
  {
    path: 'startCall',
    loadComponent: () =>
      import('./internal-call/internal-call.component').then(
        (m) => m.InternalCallComponent
      ),
  },
  {
    path: 'welcome',
    loadComponent: () =>
      import('./welcome-message/welcome-message.component').then(
        (m) => m.WelcomeMessageComponent
      ),
  },
];

if (!environment.production) {
  routes.push({
    path: 'lobby',
    loadComponent: () =>
      import(
        './webrtc-call/components/website-call/website-call.component'
      ).then((m) => m.WebsiteCallComponent),
  });
}

routes.push({
  path: '',
  pathMatch: 'full',
  redirectTo: 'welcome',
});

// Wildcard route must be last - only redirect if no other route matches
routes.push({
  path: '**',
  redirectTo: 'welcome',
});

export const appRoutes: Routes = routes;
